import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { IParamsContext, IQueryParams } from "./IParamsContext";
import { useSnackbar } from "notistack";
import { getSnackbar } from "../../utils/Snackbars";
import LoadingApp from "../../components/LoadingApp";
import { getParams } from "../../utils";

const ParamsContext = createContext<IParamsContext | undefined>(undefined);

interface ParamsProps {
  children: React.ReactNode;
}

const ParamsProvider: React.FC<ParamsProps> = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [params, setParams] = useState<IQueryParams>({});
  const [loading, setLoading] = useState<boolean>(true);

  const fetchParams = useCallback(async () => {
    try {
      const urlParams = await getParams();
      setParams(urlParams);
    } catch (err: any) {
      return enqueueSnackbar(
        getSnackbar({
          message: "Por favor, limpe o cache do navegador. Os parâmetros obtidos não foram lidos corretamente.",
          variant: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  }, [enqueueSnackbar]);

  useEffect(() => {
    fetchParams();
  }, [fetchParams]);

  return (
    <ParamsContext.Provider value={{ params }}>
      {loading ? <LoadingApp></LoadingApp> : children}
    </ParamsContext.Provider>
  );
};

const useParamsContext = (): IParamsContext => {
  const context = useContext(ParamsContext);
  if (!context) {
    throw new Error(
      "useParamsContext deve ser utilizado dentro de um ParamsProvider"
    );
  }
  return context;
};

export { useParamsContext, ParamsProvider };
